import React, {useEffect, useRef, useState} from "react";
import store from "../../reducers/createReducers";
import GlobalActions from "../../actions/global-actions";
import {decrypt, encrypt} from "../../helpers/encryption";
import ChatMessage from "./message";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import TipChatMessage from "./tip-message";
import BetChatMessage from "./bet-message";
import SvgIcon from "../svg-icon";
import {useNavigate, useSearchParams} from "react-router-dom";
import {GLOBAL_CONSTANTS} from "../../constants/global-constants";
import Loading from "../loading";
import associateServices from "../../services";
import {toast} from "react-toastify";
import InformationToast from "../toast/InformationToast";
import RainMessage from "./rain-message";
import {AUTHENTICATION_CONSTANTS} from "../../constants/authentication-constants";
import ClassWatcher from "../../hooks/ClassWatcher";
import AuthenticationActions from "../../actions/authentication-actions";
import {update} from "@intercom/messenger-js-sdk";
import stringHelper from "../../helpers/string-helper";
import {isTablet} from "react-device-detect";


const MAX_LENGTH = 200
const Chat = () => {
    const navigate = useNavigate()
    const {t} = useTranslation()
    const [searchParams, setSearchParams] = useSearchParams()

    const {agent, chatShown} = useSelector(state => state.globalReducer)
    const {authenticated, ignores, activeStreamID} = useSelector(state => state.authenticationReducer)
    const chatRef = useRef(null)
    const [chatLanguage] = useState({key: 'en'})
    const [chatActive, setChatActive] = useState(false)
    const [showMethods, setShowMethods] = useState(false)
    const [loading, setLoading] = useState(true)
    const [message, setMessage] = useState('')
    const [messages, setMessages] = useState([])
    const [onlines, setOnlines] = useState(0)
    const [autoScrollEnabled, setAutoScrollEnabled] = useState(true);
    const [visibleMessages, setVisibleMessages] = useState([])

    const isNearBottom = () => {
        if (!chatRef.current) return false;
        const el = chatRef.current;
        return el.scrollHeight - el.scrollTop - el.clientHeight < 100;
    };

    useEffect(() => {
        const el = chatRef.current;
        const shouldScroll = isNearBottom();

        // Defer scroll after DOM update
        requestAnimationFrame(() => {
            if (shouldScroll) {
                el.scrollTo({
                    top: el.scrollHeight,
                    behavior: 'smooth',
                });
            }
        });
    }, [messages]); // remove `loading`

    useEffect(() => {
        const el = chatRef?.current;
        if (!el) return;

        const handleScroll = () => {
            const threshold = 150;
            const isNearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < threshold;
            setAutoScrollEnabled(isNearBottom);
        };

        el.addEventListener('scroll', handleScroll);
        return () => el.removeEventListener('scroll', handleScroll);
    }, [chatRef?.current]);

    useEffect(() => {
        if (authenticated) {
            setListener();
        }

        // Cleanup function to remove event listeners when unmounting or when authenticated changes
        return () => {
            const chat = document.querySelector('.chat');
            const chatBtn = document.querySelector('.header__chat');
            const chatClose = document.querySelector('.chat__close');
            const emoticonsBtn = document.querySelector('.chat__emoticons-btn');
            const emoticonsClose = document.querySelector('.chat__emoticons-close');
            const lowbarChatBtn = document.querySelector('.lowbar__btn--chat');

            // Remove event listeners for chat
            chatBtn?.removeEventListener('click', toggleChat);
            chatClose?.removeEventListener('click', toggleChat);


            function toggleChat() {
                setChatActive(!chat?.classList?.contains('active'));

                chat?.classList?.toggle('active');
            }


            var emoticonsMenu = document.querySelector('.chat__emoticons');

            function toggleEmoticons() {
                emoticonsBtn?.classList?.toggle('chat__emoticons-btn--active');
                emoticonsMenu?.classList?.toggle('chat__emoticons--active');
            }

            // Remove event listeners for emoticons
            emoticonsBtn?.removeEventListener('click', toggleEmoticons);
            emoticonsClose?.removeEventListener('click', toggleEmoticons);

            if (lowbarChatBtn) {
                lowbarChatBtn?.removeEventListener('click', toggleChat);
            }

            function handleDocumentClick(event) {
                if (chat?.classList?.contains('active')) {
                    var isClickInside0 = chat.contains(event.target);
                    var isClickButton0 = chatBtn?.contains(event.target);
                    var isClickButton1 = lowbarChatBtn?.contains(event.target);

                    if (!isClickInside0 && !isClickButton0 && (!isClickButton1 || !lowbarChatBtn)) {
                        chat?.classList?.remove('active');

                    }
                }
            }

            document?.removeEventListener('click', handleDocumentClick);
        };
    }, [authenticated]);

    const setListener = () => {

        const chatButtons = document.querySelectorAll('.header__chat, .lowbar__btn--chat');
        const aside = document.querySelector('.main__aside');
        const closeButton = document.querySelector('.chat__close');

        function toggleActive() {
            this?.classList?.toggle('active');
            aside?.classList?.toggle('active');
        }

        function closeChat() {
            chatButtons.forEach(button => button?.classList?.remove('active'));
            aside?.classList?.remove('active');
        }

        chatButtons.forEach(button => {
            button.addEventListener('click', toggleActive);
        });

        closeButton.addEventListener('click', closeChat);
        const emoticonsBtn = document.querySelector('.chat__emoticons-btn');
        var emoticonsMenu = document.querySelector('.chat__emoticons');
        const emoticonsClose = document.querySelector('.chat__emoticons-close');

        function toggleEmoticons() {
            emoticonsBtn?.classList?.toggle('chat__emoticons-btn--active');
            emoticonsMenu?.classList?.toggle('chat__emoticons--active');
        }

        // Remove event listeners for emoticons
        emoticonsBtn?.addEventListener('click', toggleEmoticons);
        emoticonsClose?.addEventListener('click', toggleEmoticons);

        document.addEventListener('click', (e) => {
            if (window.innerWidth < 992) {
                const isClickInsideAside = aside.contains(e.target);
                const isClickOnButton = Array.from(chatButtons).some(button => button.contains(e.target));
                if (!isClickInsideAside && !isClickOnButton) {
                    closeChat();
                }
            }
        });
    };

    useEffect(() => {
        setVisibleMessages(
            messages
                ?.filter(op => !ignores.includes(op?.username))
                ?.slice(-100) // Get the last 100 messages
        )
    }, [messages, ignores])

    useEffect(() => {
        setShowMethods(message === '/')
    }, [message])

    const handleMessage = dt => setMessages(prevState => [...prevState, decrypt(dt)])
    const handleIgnoredCustomers = dt => store.dispatch(AuthenticationActions.setIgnoredUsers(decrypt(dt)?.ignores || []))

    const handleChatHistory = dt => {
        const data = decrypt(dt)
        setMessages(prevState => [...data || [], ...prevState])
        setTimeout(() => setLoading(false), 500)
    }

    const ignoreUser = username => {
        associateServices.ignore({username}).then(res => {

            toast(<InformationToast
                icon={res?.status === 200 ? 'ti-check' : 'ti-x'}
                message={res?.status === 200 ? t(`api-notifications.${res?.data}`) : t(`api-notifications.${res?.errors}`)}
                title={res?.status === 200 ? t(`general.information`) : t(`general.error`)}
            />)
        })
    }
    const unIgnoreUser = username => {
        associateServices.unignore({username}).then(res => {

            toast(<InformationToast
                icon={res?.status === 200 ? 'ti-check' : 'ti-x'}
                message={res?.status === 200 ? t(`api-notifications.${res?.data}`) : t(`api-notifications.${res?.errors}`)}
                title={res?.status === 200 ? t(`general.information`) : t(`general.error`)}
            />)
        })
    }
    const sendMessage = () => {
        if (!message || !authenticated || message?.length > 200)
            return false;

        if (message?.includes('/rain')) {
            setMessage('')
            searchParams.set('modal', 'rain')
            return setSearchParams(searchParams)
        }

        if (message?.includes('/ignore')) {
            setMessage('')
            const username = message?.split(' ')[1]
            if (username)
                return ignoreUser(username)
        }

        if (message?.includes('/bet')) {
            setMessage('')

            const betID = message?.split(' ')[1]

            if (betID?.includes('#')) {
                searchParams.set('modal', 'bet')
                searchParams.set('reference', betID?.replaceAll('#', ''))
                return setSearchParams(searchParams)
            }
        }


        if (message?.includes('/unignore')) {
            setMessage('')

            const username = message?.split(' ')[1]
            if (username)
                return unIgnoreUser(username)
        }

        if (message?.includes('/user')) {
            setMessage('')
            searchParams.set('modal', 'statistics')

            const username = message?.split(' ')[1]

            searchParams.set('user', username)
            return setSearchParams(searchParams)
        }

        if (message?.includes('/tip')) {
            setMessage('')
            searchParams.set('modal', 'wallet')
            searchParams.set('tab', 'tip')
            const username = message?.split(' ')[1]

            if (username)
                searchParams.set('username', username)
            return setSearchParams(searchParams)
        }

        const data = {
            message,
            language: chatLanguage?.key
        }
        window?.tcpSocket?.emit(activeStreamID ? 'send:message:stream' : 'send:message', encrypt(data))

        setMessage('')


    }

    const handleBeforeUnload = () => {
        if (window.tcpSocket?.connected) {
            window.tcpSocket?.emit('leave:chat', encrypt({
                language: chatLanguage?.key
            }));
        }
    };

    const handleOnlines = e => {
        setOnlines(e)

    }

    const handleDeleteMessage = dt => {

        try {
            const {id} = decrypt(dt)

            setMessages(prevState => prevState.filter(i => i.id !== id))

            // showNotification('Information','Chat message deleted')
        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {

        try {
            let showChat = !chatActive || !chatShown

            if (agent?.isMobile)
                showChat = true

            // window.Comm100API && window?.Comm100API?.chat.hide();


            if (window?.Comm100API) {
                window?.Comm100API?.set('livechat.button.isVisible', showChat);
                window?.Comm100API?.set('livechat.button.isVisible', showChat);
            }


            update({
                // hide_default_launcher: showChat || chatShown
                hide_default_launcher: showChat
            })
        } catch (e) {
            console.error(e)
        }
    }, [chatActive, agent?.isMobile, agent?.isTablet, chatShown, window?.Comm100API])

    useEffect(() => {
        try {
            if (window?.Comm100API) {
                var Comm100API = Comm100API || {};
                Comm100API.on = Comm100API.on || function (event, callback) {
                    if (event === 'chatStarted') {
                        document
                            .getElementById('comm100-button-9c3100fa-839d-410e-9223-9d9155d0fa43')
                            .style.pointerEvents = 'auto';
                    } else if (event === 'chatEnded') {
                        document
                            .getElementById('comm100-button-9c3100fa-839d-410e-9223-9d9155d0fa43')
                            .style.pointerEvents = 'none';
                    }
                };
            }
        } catch (e) {
            console.error(e)
        }
    }, [window?.Comm100API])

    useEffect(() => {
        setMessages([])

        // if (chatActive && window?.tcpSocket?.connected && chatLanguage?.key) {
        //
        //     store.dispatch({type: AUTHENTICATION_CONSTANTS.SET_LAST_CHAT_LANGUAGE, data: chatLanguage?.key})
        //
        //     window.tcpSocket?.emit('join:chat', encrypt({
        //         language: chatLanguage?.key
        //     }))
        //     window.tcpSocket?.on('ignore', handleIgnoredCustomers)
        //     window.tcpSocket?.on('message', handleMessage)
        //     window.tcpSocket?.on('chat:history', handleChatHistory)
        //     window.tcpSocket?.on('delete:message', handleDeleteMessage)
        //     window.tcpSocket?.on('onlines', handleOnlines)
        //
        //     window.addEventListener('beforeunload', handleBeforeUnload);
        //
        //     return () => {
        //
        //         setLoading(true)
        //         setMessages([])
        //         window.tcpSocket?.off('chat:history', handleChatHistory)
        //         window.tcpSocket?.off('message', handleMessage)
        //         window.tcpSocket?.off('delete:message', handleDeleteMessage)
        //
        //         window.tcpSocket?.emit('leave:chat', encrypt({
        //             language: chatLanguage?.key
        //         }))
        //         window.removeEventListener('beforeunload', handleBeforeUnload);
        //
        //     }
        // }


        if (activeStreamID) {
            if (chatActive && window?.tcpSocket?.connected && chatLanguage?.key) {

                window.tcpSocket?.emit('join:stream', `STREAM~${activeStreamID}`)
                window.tcpSocket?.on('message', handleMessage)
                window.tcpSocket?.on('chat:history', handleChatHistory)

                return () => {
                    setLoading(true)
                    setMessages([])
                    window.tcpSocket?.emit('leave:stream', `STREAM~${activeStreamID}`)
                    window.tcpSocket?.off('message', handleMessage)
                    window.tcpSocket?.off('chat:history', handleChatHistory)
                }

            }
        } else {
            if (chatActive && window?.tcpSocket?.connected && chatLanguage?.key) {

                store.dispatch({type: AUTHENTICATION_CONSTANTS.SET_LAST_CHAT_LANGUAGE, data: chatLanguage?.key})

                window.tcpSocket?.emit('join:chat', encrypt({
                    language: chatLanguage?.key
                }))
                window.tcpSocket?.on('ignore', handleIgnoredCustomers)
                window.tcpSocket?.on('message', handleMessage)
                window.tcpSocket?.on('chat:history', handleChatHistory)
                window.tcpSocket?.on('delete:message', handleDeleteMessage)
                window.tcpSocket?.on('onlines', handleOnlines)

                window.addEventListener('beforeunload', handleBeforeUnload);

                return () => {

                    setLoading(true)
                    setMessages([])
                    window.tcpSocket?.off('chat:history', handleChatHistory)
                    window.tcpSocket?.off('message', handleMessage)
                    window.tcpSocket?.off('delete:message', handleDeleteMessage)

                    window.tcpSocket?.emit('leave:chat', encrypt({
                        language: chatLanguage?.key
                    }))
                    window.removeEventListener('beforeunload', handleBeforeUnload);

                }
            }
        }
    }, [chatActive, chatLanguage?.key, window?.tcpSocket?.connected, activeStreamID])


    useEffect(() => {
        const el = chatRef?.current;
        if (!el || !autoScrollEnabled || loading) return;

        el.scrollTo({
            top: el.scrollHeight,
            behavior: 'smooth',
        });
    }, [visibleMessages, loading]);

    const handleCloseChat = () => {
        const chat = document.querySelector('.chat');
        chat?.classList?.remove('active');
        setChatActive(false)
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter')
            sendMessage()
    }

    const handleSetEmoji = (emoji) => {
        if (!authenticated)
            return false;

        setMessage(prevState => prevState + emoji)
    }

    const handleUserDetail = (message) => {
        navigate(stringHelper.getModalPathStatistics('statistics', message.username, searchParams))
    }

    const fetchMessages = () => {
        setChatActive(true)

    }

    function workOnClassAdd() {
        setChatActive(true)
        fetchMessages()
        if (agent?.isMobile)
            store.dispatch({
                type: GLOBAL_CONSTANTS.SET_CHAT_SHOWN,
                data: true
            })
    }

    function workOnClassRemove() {
        setChatActive(false)

        if (agent?.isMobile)
            store.dispatch({
                type: GLOBAL_CONSTANTS.SET_CHAT_SHOWN,
                data: false
            })
    }

    useEffect(() => {
        let targetNode = document.getElementById('listeners')
        new ClassWatcher(targetNode, 'active', workOnClassAdd, workOnClassRemove)
    }, [agent?.isMobile])


    return (
        <div className="main__aside" id="listeners">
            <div className="chat" id="chat">
                <div className="chat__head">
                    <div className="dropdown chat__dropdown">
                        <button
                            className="chat__dropdown-btn"
                            // type="button"
                            // id="dropdownChat"
                            // data-bs-toggle="dropdown"
                            // aria-expanded="false"
                        >
                            {/*<SvgIconExternal icon={chatLanguage?.flag}/>*/}
                            <span>{t('lowbar.chat')}</span>
                            {/*<span>{chatLanguage?.locale}</span>*/}
                            {/*<SvgIcon id={'right-down'}/>*/}
                        </button>

                        {/*<ul className="dropdown-menu chat__menu" aria-labelledby="dropdownChat">*/}
                        {/*    {*/}
                        {/*        languages?.map(lang => (*/}
                        {/*            <li*/}
                        {/*                key={lang.key}>*/}
                        {/*                <a onClick={e => setChatLanguage(lang)}>*/}
                        {/*                    <SvgIconExternal icon={lang.flag}/>*/}
                        {/*                    <span>{lang.locale}</span>*/}
                        {/*                </a>*/}
                        {/*            </li>*/}
                        {/*        ))*/}
                        {/*    }*/}

                        {/*</ul>*/}
                    </div>
                    <button className="chat__close" type="button" onClick={handleCloseChat}>
                        <SvgIcon id={'x'}/>
                    </button>
                </div>


                <div className="chat__content">
                    <div className="chat__messages" ref={chatRef} id={'chat-wrapper'}>


                        {
                            loading ? <Loading/> : visibleMessages.map(
                                msg => msg?.type === 'tip' ? <TipChatMessage key={msg.id} message={msg}/> :
                                    msg?.type === 'bet' ? <BetChatMessage key={msg.id} message={msg}/> :
                                        msg?.type === 'rain' ? <RainMessage key={msg.id} message={msg}/> :
                                            <ChatMessage
                                                handleUserDetail={handleUserDetail}
                                                key={msg.id} message={msg}/>)
                        }


                        {!autoScrollEnabled && (
                            <div
                                className="chat-autoscroll-banner"
                                onClick={() => {
                                    chatRef.current?.scrollTo({top: chatRef.current.scrollHeight, behavior: 'smooth'});
                                }}
                            >
                                <span>{t('chat.new-messages-bottom', 'New Messages')} ⬇️</span>
                            </div>
                        )}


                    </div>
                </div>


                <div className="chat__cellar">
                    <div className="chat__form">
                        <div className="form__group">
                            <input type="text"
                                   name="message"
                                   onKeyDown={handleKeyDown}
                                   className="form__input"
                                   placeholder={t(authenticated ? 'chat.placeholder' : 'chat.placeholder-unauthenticated')}
                                   value={message}
                                   maxLength={MAX_LENGTH}
                                   disabled={!authenticated}
                                   onChange={e => setMessage(e.target.value)}
                            />

                            <button className="chat__emoticons-btn" type="button">
                                <SvgIcon id={'smile'}/>
                            </button>

                        </div>
                        <div className="chat__actions">
                            {
                                !activeStreamID && parseInt(onlines || 0) > 0 &&
                                <span className="chat__online">{onlines}</span>
                            }

                            {
                                !activeStreamID &&
                                <span className="chat__count">{MAX_LENGTH - message?.length}</span>
                            }


                            <button
                                className="chat__manual"
                                type="button"
                                onClick={e => store.dispatch(GlobalActions.setModalTypeAction('chat-rules'))}>
                                <SvgIcon id={'document'}/>
                            </button>


                            <button
                                disabled={!message}
                                onClick={sendMessage}
                                className="chat__send" type="button">
                                {t('chat.send')}
                            </button>
                        </div>
                    </div>

                    <ul className={`chat__functions ${showMethods ? 'chat__functions--active' : ''}`}>
                        <li onClick={e => setMessage('/bet ')}>
                            /bet [bet id] <span>View bet</span>
                        </li>
                        <li onClick={e => setMessage('/user ')}>
                            /user @user <span>View user</span>
                        </li>
                        <li onClick={e => setMessage('/rain')}>
                            /rain <span>Make it Rain</span>
                        </li>
                        <li onClick={e => setMessage('/ignore ')}>
                            /ignore @user <span>Ignore user</span>
                        </li>
                        <li onClick={e => setMessage('/unignore ')}>
                            /unignore @user <span>Unignore user</span>
                        </li>
                    </ul>

                    <div className="chat__emoticons">
                        <div className="chat__emoticons-head">
                            <span></span>

                            <button className="chat__emoticons-close" type="button">
                                <SvgIcon id={'x'}/>
                            </button>
                        </div>
                        <ul className="chat__emoticons-list">
                            <li onClick={e => handleSetEmoji('😀')}>😀</li>
                            <li onClick={e => handleSetEmoji('😃')}>😃</li>
                            <li onClick={e => handleSetEmoji('😄')}>😄</li>
                            <li onClick={e => handleSetEmoji('😁')}>😁</li>
                            <li onClick={e => handleSetEmoji('😆')}>😆</li>
                            <li onClick={e => handleSetEmoji('😅')}>😅</li>
                            <li onClick={e => handleSetEmoji('😂')}>😂</li>
                            <li onClick={e => handleSetEmoji('🤣')}>🤣</li>
                            <li onClick={e => handleSetEmoji('🥲')}>🥲</li>
                            <li onClick={e => handleSetEmoji('🥹')}>🥹</li>
                            <li onClick={e => handleSetEmoji('☺️')}>☺️</li>
                            <li onClick={e => handleSetEmoji('😊')}>😊️</li>
                            <li onClick={e => handleSetEmoji('😇')}>😇</li>
                            <li onClick={e => handleSetEmoji('🙂')}>🙂</li>
                            <li onClick={e => handleSetEmoji('🙃')}>🙃</li>
                            <li onClick={e => handleSetEmoji('😉')}>😉</li>
                            <li onClick={e => handleSetEmoji('😌')}>😌</li>
                            <li onClick={e => handleSetEmoji('😍')}>😍</li>
                            <li onClick={e => handleSetEmoji('🥰')}>🥰</li>
                            <li onClick={e => handleSetEmoji('🥰')}>🥰</li>
                            <li onClick={e => handleSetEmoji('😘')}>😘</li>
                            <li onClick={e => handleSetEmoji('😗')}>😗</li>
                            <li onClick={e => handleSetEmoji('😙')}>😙</li>
                            <li onClick={e => handleSetEmoji('😙')}>😙</li>
                            <li onClick={e => handleSetEmoji('😋')}>😋</li>
                            <li onClick={e => handleSetEmoji('😛')}>😛</li>
                            <li onClick={e => handleSetEmoji('😝')}>😝</li>
                            <li onClick={e => handleSetEmoji('😜')}>😜</li>
                            <li onClick={e => handleSetEmoji('🤪')}>🤪</li>
                            <li onClick={e => handleSetEmoji('🤨')}>🤨</li>
                            <li onClick={e => handleSetEmoji('🧐')}>🧐</li>
                            <li onClick={e => handleSetEmoji('🤓')}>🤓</li>
                            <li onClick={e => handleSetEmoji('😎')}>😎</li>
                            <li onClick={e => handleSetEmoji('🥸')}>🥸</li>
                            <li onClick={e => handleSetEmoji('🤩')}>🤩</li>
                            <li onClick={e => handleSetEmoji('🥳')}>🥳</li>
                            <li onClick={e => handleSetEmoji('🙂')}>🙂</li>
                            <li onClick={e => handleSetEmoji('😏')}>😏</li>
                            <li onClick={e => handleSetEmoji('😒')}>😏</li>
                            <li onClick={e => handleSetEmoji('🙂')}>🙂</li>
                            <li onClick={e => handleSetEmoji('😞')}>😞</li>
                            <li onClick={e => handleSetEmoji('😞')}>😞</li>
                            <li onClick={e => handleSetEmoji('😟')}>😟</li>
                            <li onClick={e => handleSetEmoji('😕')}>😕</li>
                            <li onClick={e => handleSetEmoji('🙁')}>🙁</li>
                            <li onClick={e => handleSetEmoji('☹️')}>☹️</li>
                            <li onClick={e => handleSetEmoji('😣')}>😣️</li>
                            <li onClick={e => handleSetEmoji('😖')}>😖</li>
                            <li onClick={e => handleSetEmoji('😫')}>😫</li>
                            <li onClick={e => handleSetEmoji('😩')}>😩</li>
                            <li onClick={e => handleSetEmoji('🥺')}>🥺</li>
                            <li onClick={e => handleSetEmoji('😢')}>😢</li>
                            <li onClick={e => handleSetEmoji('😭')}>😭</li>
                            <li onClick={e => handleSetEmoji('😮')}>😮</li>
                            <li onClick={e => handleSetEmoji('😤')}>😤</li>
                            <li onClick={e => handleSetEmoji('😠')}>😠</li>
                            <li onClick={e => handleSetEmoji('😡')}>😡</li>
                            <li onClick={e => handleSetEmoji('🤬')}>🤬</li>
                            <li onClick={e => handleSetEmoji('🤯')}>🤯</li>
                            <li onClick={e => handleSetEmoji('😳')}>😳</li>
                            <li onClick={e => handleSetEmoji('🥵')}>🥵</li>
                            <li onClick={e => handleSetEmoji('🥶')}>🥶</li>
                            <li onClick={e => handleSetEmoji('😱')}>😱</li>
                            <li onClick={e => handleSetEmoji('😨')}>😨</li>
                            <li onClick={e => handleSetEmoji('😰')}>😰</li>
                            <li onClick={e => handleSetEmoji('😥')}>😥</li>
                            <li onClick={e => handleSetEmoji('😓')}>😓</li>
                            <li onClick={e => handleSetEmoji('🫣')}>🫣</li>
                            <li onClick={e => handleSetEmoji('🤗')}>🤗</li>
                            <li onClick={e => handleSetEmoji('🫡')}>🫡</li>
                            <li onClick={e => handleSetEmoji('🤔')}>🤔</li>
                            <li onClick={e => handleSetEmoji('🫢')}>🫢</li>
                            <li onClick={e => handleSetEmoji('🤭')}>🤭</li>
                            <li onClick={e => handleSetEmoji('🤫')}>🤫</li>
                            <li onClick={e => handleSetEmoji('🤥')}>🤥</li>
                            <li onClick={e => handleSetEmoji('😶')}>😶</li>
                            <li onClick={e => handleSetEmoji('😶‍🌫')}>😶‍🌫</li>
                            <li onClick={e => handleSetEmoji('😐')}>😐</li>
                            <li onClick={e => handleSetEmoji('😑')}>😑</li>
                            <li onClick={e => handleSetEmoji('😬')}>😬</li>
                            <li onClick={e => handleSetEmoji('🫨')}>🫨</li>
                            <li onClick={e => handleSetEmoji('🫠')}>🫠</li>
                            <li onClick={e => handleSetEmoji('🙄')}>🙄</li>
                            <li onClick={e => handleSetEmoji('😯')}>😯</li>
                            <li onClick={e => handleSetEmoji('😦')}>😦</li>
                            <li onClick={e => handleSetEmoji('😧')}>😧</li>
                            <li onClick={e => handleSetEmoji('😮')}>😮</li>
                            <li onClick={e => handleSetEmoji('😲')}>😲</li>
                            <li onClick={e => handleSetEmoji('🥱')}>🥱</li>
                            <li onClick={e => handleSetEmoji('😴')}>😴</li>
                            <li onClick={e => handleSetEmoji('🤤')}>🤤</li>
                            <li onClick={e => handleSetEmoji('😪')}>😪</li>
                            <li onClick={e => handleSetEmoji('😵')}>😵</li>
                            <li onClick={e => handleSetEmoji('😵')}>😵</li>
                            <li onClick={e => handleSetEmoji('🫥')}>🫥</li>
                            <li onClick={e => handleSetEmoji('🤐')}>🤐</li>
                            <li onClick={e => handleSetEmoji('🥴')}>🥴</li>
                            <li onClick={e => handleSetEmoji('🤢')}>🤢</li>
                            <li onClick={e => handleSetEmoji('🤮')}>🤮</li>
                            <li onClick={e => handleSetEmoji('🤧')}>🤧</li>
                            <li onClick={e => handleSetEmoji('😷')}>😷</li>
                            <li onClick={e => handleSetEmoji('🤒')}>🤒</li>
                            <li onClick={e => handleSetEmoji('🤕')}>🤕</li>
                            <li onClick={e => handleSetEmoji('🤑')}>🤑</li>
                            <li onClick={e => handleSetEmoji('🤠')}>🤠</li>
                            <li onClick={e => handleSetEmoji('😈')}>😈</li>
                            <li onClick={e => handleSetEmoji('👿')}>👿</li>
                            <li onClick={e => handleSetEmoji('👹')}>👹</li>
                            <li onClick={e => handleSetEmoji('👹')}>👹</li>
                            <li onClick={e => handleSetEmoji('👺')}>👺</li>
                            <li onClick={e => handleSetEmoji('🤡')}>🤡</li>
                            <li onClick={e => handleSetEmoji('💩')}>💩</li>
                            <li onClick={e => handleSetEmoji('👻')}>👻</li>
                            <li onClick={e => handleSetEmoji('💀')}>💀</li>
                            <li onClick={e => handleSetEmoji('☠️')}>☠️</li>
                            <li onClick={e => handleSetEmoji('👽')}>👽️</li>
                            <li onClick={e => handleSetEmoji('👾')}>👾️</li>
                            <li onClick={e => handleSetEmoji('🤖')}>🤖️</li>
                            <li onClick={e => handleSetEmoji('🎃')}>🎃️</li>
                            <li onClick={e => handleSetEmoji('😺')}>😺️</li>
                            <li onClick={e => handleSetEmoji('😸')}>😸️</li>
                            <li onClick={e => handleSetEmoji('😹')}>😹️</li>
                            <li onClick={e => handleSetEmoji('😻')}>😻️</li>
                            <li onClick={e => handleSetEmoji('😼')}>😼</li>
                            <li onClick={e => handleSetEmoji('😽')}>😽</li>
                            <li onClick={e => handleSetEmoji('🙀')}>🙀</li>
                            <li onClick={e => handleSetEmoji('😿')}>😿</li>
                            <li onClick={e => handleSetEmoji('😾')}>😾</li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default React.memo(Chat)
